import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import { useTl } from "../../hooks";

import { ICustomButtonProps } from "./ICustomButtonProps";
import { ActionCode } from "../../api";
import { useAuth } from "../../contexts";

interface ISaveButtonProps extends ICustomButtonProps {
  actions?: Array<ActionCode>;
}

export const SaveButton: React.FunctionComponent<ISaveButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
  style,
  className,
  actions = [],
}) => {
  const { t } = useTl();
  const { hasAction } = useAuth();
  const canSave = React.useMemo(() => hasAction(actions), [actions, hasAction]);
  return (
    <Button
      icon={IconNames.FLOPPY_DISK}
      onClick={onClick}
      text={minimal ? null : text || t("Save")}
      intent={intent}
      loading={loading}
      disabled={disabled || !canSave}
      type={onClick ? "button" : "submit"}
      style={style}
      className={className}
    />
  );
};
